var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { classNames } from "../Util";
var PrimaryNavigationItem = function (_a) {
    var item = _a.item, _b = _a.mobile, mobile = _b === void 0 ? false : _b;
    return (_jsxs("a", __assign({ href: item.href ? item.href : "#", onClick: item.onClick && (function (e) {
            e.preventDefault();
            item.onClick && item.onClick();
        }), className: classNames(item.current
            ? 'bg-blue-800 text-white'
            : 'text-blue-100 hover:bg-blue-600 hover:bg-opacity-75', 'group flex items-center px-2 py-2 text-sm font-medium rounded-md') }, { children: [_jsx(item.icon, { className: "text-blue-300 mr-4 flex-shrink-0 h-6 w-6", "aria-hidden": "true" }), item.name] }), item.name));
};
export default PrimaryNavigationItem;
